module.exports = __webpack_public_path__ + "img/3.ed15f180.jpg";